import api from '@motionelements/core/src/api/base-api-v2';

export default {
  namespaced: true,
  state: {
    balance: 100,
    list: [],
    coinsLoaded: false,
    //
    letBuyOnDemandLimit: 100,
  },
  getters: {
    getCoinsByType(state) {
      return (coinsType = 'default') => {
        const obj = state.list.find(({ type }) => type === coinsType);
        if (obj) {
          return obj;
        }
        return null;
      };
    },
  },
  actions: {
    getCoins({ commit }) {
      commit('setCoinsLoaded', false);
      return api.get('/v3/coins')
        .then((response) => {
          commit('setList', response.data.data);
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          commit('setCoinsLoaded', true);
        });
    },
  },
  mutations: {
    setList: (state, payload) => {
      state.list = payload;
    },
    setCoinsLoaded(state, boolean) {
      state.coinsLoaded = boolean;
    },
  },
};
